import React, {Component} from 'react';
import {Switch, Route, BrowserRouter} from 'react-router-dom';
import {Provider} from 'mobx-react';

import Calculator from './views/Calculator'
import About from './views/About'
import Terms from './views/Terms'
import News from './views/News'
import Cookies from './views/Cookies'
import MenuHeader from './components/MenuHeader';
import store from './store/store'
import CookieConsent from './components/CookieConsent';

import ModalDialog from './components/ModalDialog'

export default class App extends Component {
    render() {
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <div>
                        {!app &&
                        <CookieConsent/>
                        }
                        {!app &&
                        <MenuHeader/>
                        }
                        <Switch>
                            <Route exact path='/' component={Calculator}/>
                            <Route path='/about' component={About}/>
                            <Route path='/terms' component={Terms}/>
                            <Route path='/news' component={News}/>
                            <Route path='/cookies' component={Cookies}/>
                        </Switch>

                        <ModalDialog/>

                    </div>
                </BrowserRouter>
            </Provider>
        );
    }
}


// WEBPACK FOOTER //
// ./src/App.js